import { If } from "lib/@components/switch"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { Button, Stack, Typography } from "@mui/material"
import { PublishClient } from "./publishing.runtime"
import { busyWhile } from "lib/@components/busy/busy-while"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { getBasePlanId } from "routes/plan/controller/use-plan"
import { navigate } from "lib/routes/navigate"
import { useDialog } from "lib/@hooks/useDialog"
import { Bound } from "lib/@components/binding/Bound"
import { AuditModal } from "routes/regime/components/audit-modal"
import { useState } from "react"
import { rejectPlan } from "routes/plan/controller/publish-plan"
import { AuditModalTop } from "slot-definitions"
import { waitForScheduleRefresh } from "routes/schedule/lib/wait-for-schedule-refresh"

export function RejectReviewButton() {
    const [rejectionReason] = useState("")
    const { parentItem } = useBoundContext()
    const parent = parentFind(parentItem, (c) => c[PlanRoot])
    const id = getBasePlanId(parent)

    const warning = (
        <Stack spacing={1} sx={{ mt: 2, mb: 2 }} data-cy="reject-review-warning">
            <Typography variant="subtitle2">
                Rejecting these changes will send this regime back to draft, overwriting changes in the current draft
                version.
            </Typography>
        </Stack>
    )

    AuditModalTop.usePlug(warning)

    const reasonsForRejection = useDialog(
        <Bound target={rejectionReason}>
            <AuditModal
                title="Explain Your Rejection"
                label="Rejection Summary"
                field="rejectionReason"
                placeholder="Tell the regime editor why the draft has been rejected and include details of suggested changes for resubmission..."
            />
        </Bound>
    )

    return (
        <If field="activeStep.props.id" equals="Review">
            <PublishClient>
                <Secure demand="publishRegime" hide fallback={<Frag />}>
                    <Button
                        onClick={handleReject}
                        size="small"
                        variant="outlined"
                        color="error"
                        sx={{ mt: 1 }}
                        data-cy="reject-review-button"
                    >
                        Reject Changes
                    </Button>
                </Secure>
            </PublishClient>
        </If>
    )

    async function handleReject() {
        const audit = await reasonsForRejection()
        if (audit) {
            const { rejectionReason } = audit
            await busyWhile(
                async () => {
                    const auditText = `<strong>Rejection Summary:</strong><br/>${rejectionReason}`
                    await rejectPlan(id, "publish", auditText)
                    navigate(`/app/schedules?id=${id}`, { replace: true })
                },
                "Rejecting",
                waitForScheduleRefresh
            )
        }
    }
}
